import { defineComponent as _defineComponent } from 'vue'
import NewTag from '@/models/new_tag'


export default /*#__PURE__*/_defineComponent({
  __name: 'TagsDisplay',
  props: {
    tags: null,
    allowRemoveChip: { type: Boolean }
  },
  emits: ['delete'],
  setup(__props: any, { emit }) {





const handleDeleteChip = (tag: string) => {
  emit('delete', tag)
}

const formatTagDisplayName = (tag: NewTag) => {
  return tag.category ? `${tag.category}:${tag.value}` : tag.value
}

return { __sfc: true,emit, handleDeleteChip, formatTagDisplayName }
}

})